import type { SxProps, Theme } from '@mui/material/styles';

export const PDF_ROOT_SX: SxProps<Theme> = {
  p: 4,
  height: 'fit-content',
};

export const PDF_TITLE_SX: SxProps<Theme> = {
  textAlign: 'center',
  fontWeight: 'bold',
  mb: 2,
};

export const PDF_META_ROW_SX: SxProps<Theme> = {
  display: 'flex',
  mb: 2,
};

export const PDF_META_CLIENT_COLUMN_SX: SxProps<Theme> = {
  textAlign: 'left',
  mb: 2,
  width: '50%',
};

export const PDF_META_DATES_COLUMN_SX: SxProps<Theme> = {
  textAlign: 'left',
  mb: 2,
};

export const PDF_TARGET_CARD_SX: SxProps<Theme> = {
  marginBottom: 3,
  border: '1px solid #999',
  p: 3,
  borderRadius: 3,
  alignContent: 'flex-start',
};

export const PDF_TARGET_HEADER_SX: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  gap: 2,
  width: '100%',
};

export const PDF_TARGET_COLUMN_SX: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  flex: 1,
};

export const PDF_FIELD_ROW_SX: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'flex-start',
  gap: 1,
  width: '100%',
};

export const PDF_FIELD_LABEL_SX: SxProps<Theme> = {
  textAlign: 'left',
  fontWeight: 'bold',
};

export const PDF_CHART_TITLE_SX: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  my: 1,
};

export const PDF_CHART_WRAPPER_SX: SxProps<Theme> = {
  width: '100%',
  height: '100%',
  display: 'flex',
  mt: 2,
  justifyContent: 'center',
};
